import { render, staticRenderFns } from "./Obras_trabajos.vue?vue&type=template&id=212d448e&"
import script from "./Obras_trabajos.vue?vue&type=script&lang=js&"
export * from "./Obras_trabajos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports